import { FC, ReactNode } from 'react';
import style from './index.module.css';

export const PrefixBadge: FC<{ 
  children: ReactNode
}> = ({ children }) => {
  return (
    <span className={style.prefixBadge}>
      {children}
    </span>
  )
}